var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "info-container body-container" }, [
    _c(
      "div",
      { staticClass: "body-header" },
      [
        _c("el-page-header", {
          attrs: { content: "项目设置" },
          on: { back: _vm.goBack },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "info-main" },
      [
        _c(
          "el-tabs",
          { attrs: { "tab-position": "left" } },
          [
            _c("el-tab-pane", { attrs: { label: "项目信息" } }, [
              _c(
                "div",
                { staticClass: "info-box" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "updateForm",
                      staticClass: "form-container",
                      attrs: { model: _vm.projectInfo },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "100px",
                            label: "项目名称:",
                            rules: _vm.projectRule.game_name,
                            prop: "game_name",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "filter-item",
                            staticStyle: { width: "270px" },
                            attrs: {
                              placeholder: "项目名称不能为空(不超过12个字符)",
                            },
                            model: {
                              value: _vm.projectInfo.game_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.projectInfo, "game_name", $$v)
                              },
                              expression: "projectInfo.game_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "100px",
                            label: "项目图片:",
                            rules: _vm.projectRule.game_img,
                            prop: "game_img",
                          },
                        },
                        [
                          _c("UploadImg", {
                            attrs: {
                              file: _vm.projectInfo.game_img,
                              "data-type": "binary",
                            },
                            on: {
                              "update:file": function ($event) {
                                return _vm.$set(
                                  _vm.projectInfo,
                                  "game_img",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "100px",
                            label: "项目描述:",
                            rules: _vm.projectRule.game_desc,
                            prop: "game_desc",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "filter-item",
                            staticStyle: { width: "270px" },
                            attrs: {
                              type: "textarea",
                              placeholder: "项目描述(不超过100个字符)",
                            },
                            model: {
                              value: _vm.projectInfo.game_desc,
                              callback: function ($$v) {
                                _vm.$set(_vm.projectInfo, "game_desc", $$v)
                              },
                              expression: "projectInfo.game_desc",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "100px",
                            label: "项目类型:",
                            rules: _vm.projectRule.root_cate,
                            prop: "root_cate",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100px",
                                "margin-right": "20px",
                              },
                              attrs: { placeholder: "请选择" },
                              on: { change: _vm.changeRootCate },
                              model: {
                                value: _vm.projectInfo.root_cate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.projectInfo, "root_cate", $$v)
                                },
                                expression: "projectInfo.root_cate",
                              },
                            },
                            _vm._l(_vm.cateMap, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.projectInfo.second_cate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.projectInfo, "second_cate", $$v)
                                },
                                expression: "projectInfo.second_cate",
                              },
                            },
                            _vm._l(
                              _vm.cateMap[_vm.projectInfo.root_cate].children,
                              function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.name, value: item.id },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "100px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.updateProject },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("el-tab-pane", { attrs: { label: "项目管理" } }, [
              _c(
                "div",
                { staticClass: "info-box" },
                [
                  _c("div", { staticClass: "manage-title" }, [
                    _vm._v("项目管理"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteProject },
                    },
                    [_vm._v("删除项目")]
                  ),
                ],
                1
              ),
            ]),
            _c("el-tab-pane", { attrs: { label: "项目通知" } }, [
              _c(
                "div",
                { staticClass: "info-box" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "notifyForm",
                      staticClass: "form-container",
                      attrs: { model: _vm.projectInfo },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "postInfo-container-item",
                          attrs: {
                            "label-width": "120px",
                            label: "项目通知设置:",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": "1",
                              "inactive-value": "0",
                            },
                            on: { change: _vm.changeNotify },
                            model: {
                              value: _vm.projectInfo.notice_switch,
                              callback: function ($$v) {
                                _vm.$set(_vm.projectInfo, "notice_switch", $$v)
                              },
                              expression: "projectInfo.notice_switch",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("el-tab-pane", { attrs: { label: "自定义推荐值" } }, [
              _c(
                "div",
                { staticClass: "info-box" },
                [
                  _vm._l(_vm.targetInfo, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "target-item" },
                      [
                        _c("div", { staticClass: "target-title" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        _c(
                          "el-table",
                          {
                            ref: "planTable",
                            refInFor: true,
                            attrs: {
                              data: item.data,
                              border: "",
                              fit: "",
                              "highlight-current-row": "",
                              "header-cell-style": {
                                background: "#F2F8FF",
                                color: "#333333",
                              },
                              width: "100%",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "machine", label: "机型类型" },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "low", label: "低优先级" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            type: "number",
                                          },
                                          model: {
                                            value: row.data[0],
                                            callback: function ($$v) {
                                              _vm.$set(row.data, 0, $$v)
                                            },
                                            expression: "row.data[0]",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "low", label: "中优先级" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            type: "number",
                                          },
                                          model: {
                                            value: row.data[1],
                                            callback: function ($$v) {
                                              _vm.$set(row.data, 1, $$v)
                                            },
                                            expression: "row.data[1]",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "low", label: "高优先级" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            size: "mini",
                                            type: "number",
                                          },
                                          model: {
                                            value: row.data[2],
                                            callback: function ($$v) {
                                              _vm.$set(row.data, 2, $$v)
                                            },
                                            expression: "row.data[2]",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveTarget },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }